import type { CSSProperties, ReactElement, ReactNode } from "react";
import { isValidElement } from "react";
import css from "./Table.module.css";

export type TableColumn<T> = {
  title: ReactNode;
  cell: (item: T) => ReactNode;
  thPadding?: string;
  padding?: string;
  width?: number | string;
  hide?: boolean;
  align?: CSSProperties["textAlign"];
};

export type TableProps<T> = {
  cols: ReadonlyArray<TableColumn<T>>;
  id: (item: T, index: number) => string | number;
  data: ReadonlyArray<T | ReactElement<unknown>>;
  vAlign?: string;
  highlight?: [string, string];
};

export function Table<T>(props: TableProps<T>) {
  return (
    <table className={css.root}>
      <thead className={css.head}>
        <tr>
          {props.cols.map((col, i) => {
            const hide = col.hide ?? false;
            return (
              !hide && (
                <th
                  key={i}
                  scope="col"
                  style={{
                    padding: col.thPadding ?? "6px 6px",
                    textAlign: col.align,
                    width: col.width,
                  }}
                >
                  {col.title}
                </th>
              )
            );
          })}
        </tr>
      </thead>
      <tbody>
        {props.data.map((item, index) => {
          if (isValidElement(item)) {
            return item;
          }
          let vetticalAlign = props.vAlign ?? "middle";
          return (
            <tr
              key={props.id(item, index)}
              style={{
                background: "#292524",
                borderBottom: "1px solid #1c1a18",
                verticalAlign: vetticalAlign,
              }}
            >
              {props.cols.map((col, i) => {
                const hide = col.hide ?? false;
                const align = col.align;
                return (
                  !hide && (
                    <td
                      key={i}
                      style={{
                        padding: col.padding ?? "4px 6px",
                        textAlign: align,
                      }}
                    >
                      {col.cell(item)}
                    </td>
                  )
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export function renderTableTr(
  opts: {
    key: string | number;
  },
  children: ReactNode
) {
  return (
    <tr
      key={opts.key}
      style={{
        background: "#292524",
        borderBottom: "1px solid #1c1a18",
      }}
    >
      {children}
    </tr>
  );
}